import { ButtonBase } from "@material-ui/core"
import type { ReactElement } from "react"
import { Body1 } from ".."

import "./title-card.styles.scss"
export interface ITitleCardProps {
  title: string
  onClick?: () => void
}

export function TitleCard(props: ITitleCardProps): ReactElement {
  const { title, onClick } = props

  return (
    <ButtonBase
      onClick={onClick}
      className="title-card"
      data-mdat="referrer"
      data-mdat-item-id="title-card"
      data-mdat-label={title}
    >
      <Body1>{title}</Body1>
    </ButtonBase>
  )
}
